import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const DateGroupHeader = styled.div`
  padding: ${Spacing.S8};
`
